import styles from "./Icon.module.css";

const Icon = ({ src, alt, isActive }) => {
  return (
    <div className={`${styles.icon} ${isActive ? styles.active : ""} `}>
      <img src={src} alt={alt} className={styles.iconImage} />
    </div>
  );
};

export default Icon;
